import { environment } from 'src/environments/environment';

// MSAL keys its temporary cache entries with the client id, so the plain
// 'msal.interaction.status' key removes nothing.
const INTERACTION_STATUS_KEY = `msal.${environment.msalConfig.auth.clientId}.interaction.status`;

/**
 * MSAL leaves the interaction flag set when a popup is abandoned (closed by the user,
 * blocked by the browser, or timed out). It lives in sessionStorage, so every later
 * loginPopup/logoutPopup fails with interaction_in_progress until the tab is closed.
 */
export function clearStaleMsalInteraction(): void {
  sessionStorage.removeItem(INTERACTION_STATUS_KEY);
  localStorage.removeItem(INTERACTION_STATUS_KEY);
}

export function isInteractionInProgressError(error: any): boolean {
  return error?.errorCode === 'interaction_in_progress';
}

export function isUserCancelledError(error: any): boolean {
  return error?.errorCode === 'user_cancelled';
}
